import { locale } from 'icreate/common/validators/yup-locale';
import * as yup from 'yup';
import { string, ObjectSchema, object } from 'icreate/common/validators/index';
yup.setLocale(locale);

export const reasonMaxLength = 200;

class RejectReason {
    reason: string;
}
export function RejectReasonValidator(): ObjectSchema<RejectReason> {
    return object({
        reason: string().nonNullable().required().max(reasonMaxLength).strict(),
    })
        .noUnknown()
        .strict();
}
